/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type CouponDTO = {
  id: string;
  name: string;
  code: string;
  discount: number;
};

interface CouponData {
  CouponData: CouponDTO[];
}

interface CouponResponse {
  data?: CouponData;
  error?: ApiError;
}

export const GetCouponById = async (id: string): Promise<CouponResponse> => {
  try {
    const response = await axios.get(`/coupon/${id}`);
    return { data: { CouponData: [response.data] } }; // Adjusted to match the expected structure
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
